import { DataService } from './../core.module/services/data.service';
import { LoopBackConfig } from './../shared/sdk/lb.config';
import { PlayerVersion } from './../shared/sdk/models/PlayerVersion';
import { Component, OnInit } from '@angular/core';
import { PlayerVersionApi } from '../shared/sdk/services/custom/PlayerVersion';
import { DataURLS } from '../shared/base.url';

@Component({
  selector: 'app-player-download',
  templateUrl: './player-download.component.html',
  styleUrls: ['./player-download.component.css']
})
export class PlayerDownloadComponent implements OnInit {

  public playerVersions = [];
  public winVersions = [];
  public linuxVersions = [];
  public androidVersions = [];

  constructor(
    public playerVersionApi: PlayerVersionApi,
    public dataService: DataService
  ) {
    LoopBackConfig.setBaseURL(DataURLS.BASE_URL);
    LoopBackConfig.setApiVersion(DataURLS.API_VERSION);
  }

  ngOnInit() {

    this.getPlayerVersions();



  }

  async getPlayerVersions() {
    try {
      this.playerVersions = await this.playerVersionApi.find({order: 'updatedAt DESC'}).toPromise();

      this.winVersions = this.playerVersions.filter(item => { return item.platform === 'win'; });
      this.linuxVersions = this.playerVersions.filter(item => { return item.platform === 'linux'; });
      this.androidVersions = this.playerVersions.filter(item => { return item.platform === 'android'; });

    } catch (error) {
      console.log(error.message);
    }
  }

  async deletePlayerVersion(pv) {
    await this.playerVersionApi.deleteById(pv.id).toPromise();
    await this.getPlayerVersions();
  }

}



// WEBPACK FOOTER //
// ./src/app/player-download/player-download.component.ts